import { render, staticRenderFns } from "./newhome.vue?vue&type=template&id=2dd77b0f&scoped=true"
import script from "./newhome.vue?vue&type=script&lang=js"
export * from "./newhome.vue?vue&type=script&lang=js"
import style0 from "./newhome.vue?vue&type=style&index=0&id=2dd77b0f&prod&lang=less&scoped=true"
import style1 from "./newhome.vue?vue&type=style&index=1&id=2dd77b0f&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd77b0f",
  null
  
)

export default component.exports